module.exports = __webpack_public_path__ + "img/New PACI Flow AR - Enable Authentication - 6.d56ef179.png";